import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { useStorePrice } from '@/common/hooks/apple-price';
import { formatUsd } from '@/components/Shop/ui/format';
import { SaleTag } from '@/components/Shop/ui/ShopUi';
import { vipPeriodLabel } from '@/components/Vip/vipPeriod';

import css from './styles.module.scss';

interface VipPeriodCardProps {
  days: number;
  price: number;
  oldPrice: number;
  sale?: number;
  active: boolean;
  /** iOS app: show the App Store price of this VIP duration instead */
  appleVipDays?: number;
  onClick: () => void;
}

/** One VIP period of "Choose a period", 88px high. */
const VipPeriodCard: FC<VipPeriodCardProps> = ({
  days,
  price,
  oldPrice,
  sale,
  active,
  appleVipDays,
  onClick,
}) => {
  const { t } = useTranslation();
  const storePrice = useStorePrice(undefined, appleVipDays);

  return (
    <button
      type="button"
      className={cn(css.period, active && css.periodActive)}
      onClick={onClick}
    >
      <span className={css.periodDays}>{vipPeriodLabel(days, t)}</span>
      <span className="absolute left-2 bottom-2 flex flex-col items-start gap-0.5">
        {!storePrice && oldPrice > price && (
          <span className={css.periodOldPrice}>{formatUsd(oldPrice)}</span>
        )}
        <span className={css.periodPrice}>
          {storePrice ?? formatUsd(price)}
        </span>
      </span>
      {!storePrice && !!sale && (
        <SaleTag text={`-${sale}%`} className={css.periodSale} leftFoldOnly />
      )}
    </button>
  );
};

export { VipPeriodCard };
